const styles = (theme) => ({
  root: {
    width: "100%",
    background: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0px 0px 35px 0px rgba(94, 85, 126, 0.15)",

    "& Button": {
      minWidth: "237px",
    },
  },
  container: {
    margin: "45px auto",
  },
  title: {
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "32px",
    lineHeight: "45px",
    textAlign: "center",
    color: "#1E304B",
    margin: "45px auto",
  },
  headerTitle: {
    // fontFamily: "Noto Sans SC",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "60px",
    lineHeight: "70px",
    textAlign: "center",
    color: "#FFFFFF",
  },
  headerTitleSecondary: {
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "24px",
    lineHeight: "29px",
    textAlign: "center",
    color: "#FFFFFF",
    mixBlendMode: "normal",
    opacity: 0.6,
    margin: "20px auto 80px auto",
  },
  tableHeader: {
    height: "80px",
    "& td": {
      // fontFamily: "Noto Sans SC",
      fontStyle: "normal",
      fontWeight: "300 !important",
      fontSize: "20px",
      lineHeight: "28px",
      color: "#ACAEBC",
      padding: "26px 25px",
    },
  },
  tableBody: {
    height: "100px",
    "& td": {
      // fontFamily: "Noto Sans SC",
      fontStyle: "normal",
      fontSize: "20px",
      lineHeight: "24px",
      padding: "38px 25px",
    },
  },
  icon: {
    width: "36px",
    height: "36px",
    position: "relative",
    marginTop: "-6px",
    marginRight: "8px",
    display: "inline-block",
    verticalAlign: "middle",
  },
  walletIcon: {
    width: "24px",
    height: "24px",
    marginRight: "8px",
  },
  iconSecondary: {
    width: "51px",
    height: "24px",
    marginLeft: "8px",
  },
  button: {
    background: "linear-gradient(135deg, #42D9FE 0%, #2872FA 100%, #42D9FE)",
    borderRadius: "26px",
    // fontFamily: "Noto Sans SC",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "20px",
    color: "#FFFFFF",
    minWidth: "115px",
    marginTop: "-15px",
    "&:hover": {
      background: "linear-gradient(315deg, #4DB5FF 0%, #57E2FF 100%, #4DB5FF)",
    },
    "&.Mui-disabled": {
      background:
        "linear-gradient(135deg, rgb(66, 217, 254, 0.12) 0%, rgb(40, 114, 250,0.12) 100%, rgb(66, 217, 254, 0.12))",
      color: "#FFFFFF",
    },
  },
  buttonSecondary: {
    background: "linear-gradient(135deg, #FF3A33 0%, #FC06C6 100%, #FF3A33)",
    borderRadius: "26px",
    // fontFamily: "Noto Sans SC",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "20px",
    color: "#FFFFFF",
    minWidth: "115px",
    marginTop: "-15px",
    "&:hover": {
      background: "linear-gradient(315deg, #FF78E1 0%, #FF736E 100%, #FF78E1)",
    },
    "&.Mui-disabled": {
      background:
        "linear-gradient(135deg, rgb(255, 58, 51, 0.12) 0%, rgb(252, 6, 198, 0.12) 100%, rgb(255, 58, 51, 0.12))",
      color: "#FFFFFF",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%",
  },
  actions: {
    height: "79px",
    padding: "46px 36px",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    color: "#C0C1CE",
    overflowX: "scroll",
    overflowY: "hidden",
  },
  actionsSm: {
    textAlign: "left",
    color: "#1E304B",
    fontFamily: "Oswald",
    fontSize: "24px",
    fontWeight: 300,
    display: "block",
    padding: "13px 32px",
    "& span": {
      float: "right",
    },
  },
  paperTitle: {
    // fontFamily: "Noto Sans SC",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "20px",
    lineHeight: "28px",
    color: "#ACAEBC",
  },
  paperTitleSecondary: {
    fontFamily: "Oswald",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "46px",
    lineHeight: "56px",
    color: "#1E304B",
    paddingTop: "18px",

    "& .small-text": {
      fontSize: "20px",
      lineHeight: "28px",
      color: "#454862",
    },
  },
  paperTip: {
    // fontFamily: "Noto Sans SC",
    fontStyle: "normal",
    fontWeight: "300",
    fontSize: "16px",
    lineHeight: "22px",
    textAlign: "center",
    color: "#ACAEBC",
    margin: "24px auto 0px auto",
  },
  divider: {
    position: "absolute",
    height: "50%",
    left: "50%",
    top: "25%",
  },
  balanceBar: {
    textAlign: "left",
    color: "white",
    fontSize: "24px",
    "& div": {
      display: "flex",
    },
  },
  collapse: {
    background: "#EEF6FF",
    padding: "10px 22px",
    textAlign: "left",
    fontSize: "18px",
    color: "#C0C1CE",
    position: "relative",
  },
  customAlert: {
    "& .MuiAlert-message": {
      width: "100%",
      textAlign: "center",
    },
  },
});

export default styles;
